module.exports = __webpack_public_path__ + "static/twitter-87dfb9b35a216fdbe30306076d53a70e.png";